import React from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';
import { useRecoilValue } from 'recoil';
import styled from 'styled-components';

import FCThumbnail from '@/components/Thumbnail/FC';
import { PlannerSummary } from '@/models/ina';
import useStartChatting from '@/hooks/chat/useStartChatting';
import { loginState } from '@/recoil';
import { FontStyle } from '@/utils/StyleUtil';
interface IProps {
    plannerInfo: PlannerSummary | null;
}

const PlannerPart = ({ plannerInfo }: IProps) => {
    const router = useRouter();

    const plannerId = plannerInfo?.id ?? undefined;
    const plannerName = plannerInfo ? `${plannerInfo.name} 플래너` : '응답할 수 없는 플래너입니다';
    const plannerAge = plannerInfo?.age ?? undefined;
    const plannerSex = plannerInfo?.sex ?? undefined;
    const plannerAboutMe = plannerInfo?.introduce ?? undefined;

    const designatedPlannerId = useRecoilValue(loginState).designatedPlannerId;

    const promotionLimitedLockIn = sessionStorage.getItem('accessed-promotion') === 'true';

    const plannerData = {
        id: plannerId,
        name: plannerInfo?.name ?? undefined,
        age: plannerAge,
        sex: plannerSex,
    };

    const { startChatting } = useStartChatting({ plannerData });

    const showPlannerProfile = async () => {
        if (
            plannerId &&
            !promotionLimitedLockIn &&
            (designatedPlannerId === undefined || designatedPlannerId === -1 || designatedPlannerId === plannerId)
        ) {
            router.push({
                pathname: `/planner/${plannerId}`,
            });
        }
    };

    const simplePlannerProfile = () => {
        if (plannerId) {
            return (
                <div className="planner_text">
                    <div className="name">{plannerName}</div>
                    <div className="intro">{plannerAboutMe}</div>
                </div>
            );
        }
        return (
            <div className="planner_text">
                <div className="resigned">{plannerName}</div>
            </div>
        );
    };

    return (
        <>
            <AnswerHeader isAlive={Boolean(plannerId)}>
                <PlannerContainer onClick={showPlannerProfile}>
                    <FCThumbnail age={plannerAge} sex={plannerSex} width="46px" height="46px" />
                    {/*{simplePlannerProfile()}*/}
                </PlannerContainer>
                {simplePlannerProfile()}
                {plannerId &&
                    (designatedPlannerId === undefined || designatedPlannerId === -1) &&
                    !promotionLimitedLockIn && <Chatting onClick={startChatting}>상담하기</Chatting>}
            </AnswerHeader>
            {/*{plannerId && (*/}
            {/*    <Introduct>*/}
            {/*        <div className="image_wrapper">*/}
            {/*            <Image src="/img/ina/left_quote@3x.png" alt="left_quotes" width={15} height={10} />*/}
            {/*        </div>*/}
            {/*        <span>{plannerAboutMe}</span>*/}
            {/*        <div className="image_wrapper">*/}
            {/*            <Image src="/img/ina/right_quote@3x.png" alt="right_quotes" width={15} height={10} />*/}
            {/*        </div>*/}
            {/*    </Introduct>*/}
            {/*)}*/}
        </>
    );
};

const AnswerHeader = styled.div<{ isAlive: boolean }>`
    display: flex;
    //${({ theme }) => theme.flex.justifyBetween};
    align-items: center;

    margin-bottom: ${({ isAlive }) => (isAlive ? '13px' : '16px')};

    //white-space: nowrap;

    .planner_text {
        ${({ theme }) => theme.flex.flexColumn};

        overflow: hidden;
        //text-overflow: ellipsis;
        //white-space: nowrap;
        margin-right: 14px;

        .name {
            ${FontStyle(16, 24, '500', '#222222', -1)}
            white-space: nowrap;
            overflow: hidden;
            text-overflow: '...';
        }
        .intro {
            ${FontStyle(12, 20, '400', '#ACACAC', -1)};
            overflow: hidden;
            text-overflow: '...';
            white-space: nowrap;
        }
        .resigned {
            ${FontStyle(14, 22, '500', '#686868', -1)}
        }
        .introduce {
            ${FontStyle(12, 20, '400', '#acacac', -1)}
        }
    }
`;

const PlannerContainer = styled.div`
    ${({ theme }) => theme.flex.flexOnly};
    ${({ theme }) => theme.flex.justifyCenter};
    flex-shrink: 0;
    margin-right: 8px;
`;

const Chatting = styled.div`
    display: flex;
    flex-shrink: 0;
    margin-left: auto;
    ${({ theme }) => theme.flex.justifyCenter}
    width: 62px;
    height: 28px;
    border-radius: 22px;
    background-color: ${({ theme }) => theme.colors.primary};
    padding: 5px 10px;

    ${FontStyle(12, 18, '500', '#ffffff', -1)}
`;

const Introduct = styled.div`
    ${({ theme }) => theme.flex.flexOnly};
    ${({ theme }) => theme.flex.justifyBetween}
    width: 100%;
    height: 36px;
    margin-bottom: 20px;
    padding: 0 12px;
    border-radius: 6px;
    background-color: #f9f9f9;
    gap: 12px;

    span {
        max-width: 202px;
        width: 202px;
        text-align: center;
        ${({ theme }) => theme.settingByBrowser.lineClamp(1)};
        ${FontStyle(12, 20, '400', '#888888', -1)}
    }

    .image_wrapper {
        min-width: 15px;
        min-height: 15px;
    }
`;

export default PlannerPart;
